import PropTypes from 'prop-types'
import React from 'react'
import Logo from './Logo'
import Message from './Message'
import Barcode from './Barcode'
import Footer from './Footer'
import NotFound from './NotFound'
import QRCode from './QRCode'
import { useState } from 'react';

function Item({ logo, logoLink, message, barcode, qrcode, footer, footerLink, footerText }) {
    const [displayError, setDisplayError] = useState(false)
    return (
        <>
            { displayError ?
                <NotFound />
            :
                <>
                <div className="header">
                    { logo && <Logo logoLink={logoLink} /> }
                    <Message text={message}/>
                </div>
                <div className="item">
                    { barcode && <><Barcode setDisplayError={setDisplayError} /><div className="break"></div></> }
                    { qrcode && <><QRCode setDisplayError={setDisplayError} /><div className="break"></div></> }
                    <Footer showFooter={footer} text={footerText} link={footerLink} /><div className="break"></div>
                </div>
                </>
            }
            
        </>
    )
}

Item.propTypes = {
    logo: PropTypes.bool,
    logoLink: PropTypes.string,
    message: PropTypes.string,
    barcode: PropTypes.bool,
    qrcode: PropTypes.bool,
    footer: PropTypes.bool,
    footerText: PropTypes.string,
    footerLink: PropTypes.string
}

Item.defaultProps = {
    logo: false,
    logoLink: "",
    message: "",
    barcode: true,
    qrcode: false,
    footer: false,
    footerLink: "",
    footerText: ""
}

export default Item
